import DetailSection from "../components/DetailSection";
import Badge from "../../../../../ui/Badge/Badge";
import FormattedDate from "../../../../../ui/FormattedDate/FormattedDate";
import {
  FragmentType,
  getFragmentData,
  graphql,
} from "../../../../../__generated__/gql";
import Avatar from "../../../../../ui/Avatar/Avatar";
import StatusBadge from "../../../../../components/StatusBadge/StatusBadge";
import toSentenceCase from "../../../../../util/toSentenceCase";

const ArticleDetailsDetailsFragment = graphql(/* GraphQL */ `
  fragment ArticleDetailsDetails on Article {
    createdBy {
      id
      status
      firstName
      lastName
      email
      imageUrl
    }
    createdAt
    updatedAt
    generatedAt
    language
    ...StatusBadge
  }
`);

function Details({
  isOpen,
  setIsOpen,
  data,
}: {
  isOpen: boolean;
  setIsOpen: (value: string) => void;
  data: FragmentType<typeof ArticleDetailsDetailsFragment>;
}) {
  const article = getFragmentData(ArticleDetailsDetailsFragment, data);
  const { createdBy, createdAt, updatedAt, generatedAt, language } = article;

  return (
    <DetailSection
      title="Details"
      isOpen={isOpen}
      setIsOpen={() => setIsOpen("Details")}
      details={[
        {
          name: "Status",
          children: <StatusBadge data={article} />,
        },
        {
          name: "Created by",
          children: createdBy ? (
            <Avatar
              size="small"
              imageUrl={createdBy?.imageUrl || ""}
              firstName={createdBy?.firstName || ""}
              lastName={createdBy?.lastName || ""}
            />
          ) : (
            "-"
          ),
        },
        {
          name: "Created",
          children: (
            <Badge
              showDot={false}
              color="default"
              variant="badge"
              size="medium"
            >
              <FormattedDate date={createdAt} />
            </Badge>
          ),
        },
        {
          name: "Generated",
          children: generatedAt ? (
            <Badge
              showDot={false}
              color="default"
              variant="badge"
              size="medium"
            >
              <FormattedDate date={generatedAt} />
            </Badge>
          ) : (
            "-"
          ),
        },
        {
          name: "Updated",
          children: (
            <Badge
              showDot={false}
              color="default"
              variant="badge"
              size="medium"
            >
              <FormattedDate date={updatedAt} />
            </Badge>
          ),
        },
        ...(language
          ? [
              {
                name: "Language",
                children: (
                  <Badge
                    showDot={false}
                    color="default"
                    variant="badge"
                    size="medium"
                  >
                    {language.includes("english")
                      ? `${toSentenceCase(language.split("-")[0])} (${language
                          .split("-")[1]
                          .toUpperCase()})`
                      : toSentenceCase(language)}
                  </Badge>
                ),
              },
            ]
          : []),
      ]}
    />
  );
}

export default Details;
